"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.restartMachine = restartMachine;
async function restartMachine(machineRepo, id) {
    return await machineRepo.restartMachine(id);
}
